(function () {
  function initGallery(root) {
    var mainImg = root.querySelector('[data-case-gallery-main]');
    var mainCaption = root.querySelector('[data-case-gallery-caption]');
    var thumbs = root.querySelectorAll('[data-case-gallery-thumb]');

    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        var caption = thumb.getAttribute('data-caption') || '';

        if (src) mainImg.setAttribute('src', src);
        if (srcset) {
          mainImg.setAttribute('srcset', srcset);
        } else {
          mainImg.removeAttribute('srcset');
        }

        if (mainCaption) {
          if (caption) {
            mainCaption.textContent = caption;
            mainCaption.hidden = false;
          } else {
            mainCaption.textContent = '';
            mainCaption.hidden = true;
          }
        }

        thumbs.forEach(function (item) {
          item.classList.toggle('is-active', item === thumb);
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-case-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
